import React, { useCallback, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import LinkedIn from '@mui/icons-material/LinkedIn';
import { getCandidatsAndContacts } from '../../../../services/CandidatService';
import { withSnackbar } from '../../../../utils/SnackbarHOC';
import { updateObjectStateValue } from '../../../../utils/FunctionHelpers';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../../../utils/gridStyles';
import { DataGrid } from '../../../../components/SortableDataGrid/SortableDataGrid';

const CustomToolbar = makeGridToolbar('Collègues');

const Collegues = ({ snackbarShowMessage, societeId }) => {
  const [collegues, setCollegues] = useState({ isLoading: false, data: [] });

  const loadData = useCallback(() => {
    updateObjectStateValue(setCollegues, { isLoading: true, data: [] });
    getCandidatsAndContacts(societeId)
      .then(({ data }) => updateObjectStateValue(setCollegues, { isLoading: false, data: data.data }))
      .catch(() => snackbarShowMessage('Erreur de chargements des collegues', 'error', 4000))
      .finally(() => updateObjectStateValue(setCollegues, { isLoading: false }));
  }, [societeId, snackbarShowMessage]);

  useEffect(() => { loadData(); }, [loadData]);

  const columns = [
    {
      field: 'name', headerName: 'NOM', width: 160,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'fonction', headerName: 'FONCTION', flex: 1, minWidth: 200,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'date', headerName: 'MAJ', width: 120,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#64748b' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'linkedin', headerName: 'LINKEDIN', width: 80, align: 'center', headerAlign: 'center', sortable: false,
      renderCell: (p) => p.value ? (
        <a href={p.value} target="_blank" rel="noreferrer" style={{ color: '#0a66c2', lineHeight: 0 }}>
          <LinkedIn sx={{ fontSize: 20 }} />
        </a>
      ) : <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>,
    },
    {
      field: 'telephone', headerName: 'TÉLÉPHONE', width: 140,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'consultant', headerName: 'TALENT MANAGER', width: 160,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'Statut', headerName: 'STATUT', width: 120,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
  ];

  const rows = (collegues.data || []).map((c, i) => ({ ...c, _id: c.id ?? i }));

  return (
    <Box sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: '44vh', minHeight: 300, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id}
        loading={collegues.isLoading}
        pageSizeOptions={[50, 100]}
        disableRowSelectionOnClick
        showToolbar
        slots={{ toolbar: CustomToolbar }}
        slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
        localeText={gridLocaleText}
        sx={commonGridSx}
      />
    </Box>
  );
};

export default withSnackbar(Collegues);
